<div class="inline-block">
  <app-jackpot></app-jackpot>
</div>
